import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { COMPANY_TYPE } from 'src/app/core/enums/company-type.enum';
import { SiteModel } from '../../../../../core/models/site.model';

@Component({
    selector: 'app-location-selection-temp1',
    templateUrl: './location-selection.temp1.component.html',
    styleUrls: ['./location-selection.temp1.component.scss']
})
export class LocationSelectionTemp1Component implements OnInit {
    @Input() sites: Array<SiteModel>;
    @Input() selectedSite: SiteModel;
    @Input() currentCompanyType$: Observable<COMPANY_TYPE>;
    @Output() addNewSite: EventEmitter<any> = new EventEmitter<any>();
    @Output() updateSite: EventEmitter<SiteModel> = new EventEmitter<SiteModel>();

    CompanyType = COMPANY_TYPE;
    showLocations: boolean;
    searchText: string;

    constructor() { }

    ngOnInit(): void {
    }

    locationsOpened(isOpen) {
        this.showLocations = isOpen;
        this.searchText = null;
    }

    preventPopupClose(e) {
        e.stopPropagation();
    }

    updateSelectedSite(site: SiteModel) {
        this.updateSite.emit(site);
    }

    onAddNewSite() {
        this.addNewSite.emit();
    }

}
